import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./shopcatagory.css";

function CategoryCard({ category, index }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/ProductList", {
      state: { categoryName: category.name },
    });
  };

  return (
    <div className="col-lg-4 col-md-6">
      <div
        className={`premium-category-card card-${index + 1}`}
        onClick={handleClick}
      >
        <div className="premium-img-wrap">
          <img src={category.image} alt={category.name} />
        </div>

        <div className="premium-category-content">
          <span>Jyotirvani Collection</span>
          <h3>{category.name}</h3>
          <p>Explore premium spiritual products selected for purity and energy.</p>

          <button>
            View Products <i className="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

const ShopCategoryCard = () => {
  const [categories, setCategories] = useState([]);

  const defaultImage =
    "https://dashboard.jyotirvani.com/uploads/defaultImage/defaultImage.png";

  useEffect(() => {
    fetch("https://dashboard.jyotirvani.com/api/shop-categories")
      .then((res) => res.json())
      .then((res) => {
        if (res.status && Array.isArray(res.data)) {
          setCategories(
            res.data.map((item) => ({
              id: item.id,
              name: item.name,
              image: item.image || defaultImage,
            }))
          );
        }
      })
      .catch((err) => {
        console.log("Shop Category API Error:", err);
      });
  }, []);

  return (
    <section className="ra-shop-catagory">
      <div className="container">
        <div className="premium-shop-heading">
          <span>Shop With Jyotirvani</span>
          <h1>Explore Sacred Categories</h1>
          <p>
            Discover gemstones, rudraksha, bracelets and spiritual products
            crafted for positivity, peace and prosperity.
          </p>
        </div>

        <div className="row g-4">
          {categories.length > 0 ? (
            categories.map((cat, index) => (
              <CategoryCard category={cat} index={index} key={cat.id} />
            ))
          ) : (
            <div className="col-12">
              <p className="no-category">No categories found.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ShopCategoryCard;